import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";
var token = localStorage.getItem("x-access-token");




export const fetchBudget = createAsyncThunk("budget/allBudget", async () => {
  const response = await fetch(Configuration.BACK_BASEURL + "budget/allBudget", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

  });
  const budget = await response.json();
  return budget;
});



export const fetchBudgetForListe = createAsyncThunk("budget/allBudgetForList", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "budget/allBudgetForList", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const budget = await response.json();
  return budget;
});



export const checkProduit = createAsyncThunk("budget/checkProduit", async (action) => {

  const response = await fetch(Configuration.BACK_BASEURL + "budget/checkProduit", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token // Make sure 'token' is defined
    },
    body: JSON.stringify(action)
  });
  const budget = await response.json();
  return budget;
});


//upload BL file
export const saveFile = createAsyncThunk("budget/saveFile", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "budget/saveFile", {
    method: 'POST',
    headers: {
      'Accept': 'application/*',
      'x-access-token': token,
    },
    body: action
  });
  const budget = await response.json();
  return budget;
});



export const verifEntete = createAsyncThunk("budget/verifEntete", async (action) => {
  // console.log(action)
  const response = await fetch(Configuration.BACK_BASEURL + "budget/verifEntete", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const budget = await response.json();
  return budget;
});



export const AddedExcel = createAsyncThunk("budget/enteteAddedExcel", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "budget/enteteAddedExcel", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const budget = await response.json();
  return budget;
});


// for export excel
export const fetchBudgetOnly = createAsyncThunk("budget/allhisBudget", async (action) => {
  console.log(action)
  const response = await fetch(Configuration.BACK_BASEURL + "budget/allhisBudget", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const budget = await response.json();
  return budget;
});



export const BudgetDeleted = createAsyncThunk("budget/delete", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "budget/delete/" + action.id, {
    method: 'DELETE',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
  });
  const budget = await response.json();
  return budget;
});


export const verifExistance = createAsyncThunk("budget/verifExistance", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "budget/verifExistance", {
      method: 'POST',
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token': token
      },
      body: JSON.stringify(action)
  });
  const budget = await response.json();
  return budget;
});



const budgetReduce = createSlice({
  name: "budget",
  initialState: {
    entities: [],
    loading: false,
  },
  reducers: {
  },
  extraReducers: {
  },
});


export default budgetReduce.reducer;